import {useState} from "react";
import styles from "@styles/pages/recipes/detail.module.scss";
import Link from "next/link";
import {RecipesList} from "@components/product-inner/recipes-list";
import SILink from "@components/link/silink";
import * as React from "react";
import {useRouter} from 'next/router'
import qs from "qs";
import {strapi} from "@api/Strapi";
import Head from "next/head";

// @ts-ignore
function RecipesDetail({recipeDetail, relatedRecipes, recipesSchema}) {

    // to share current url
    const router = useRouter();
    /**
     * Serving size input value holder
     */
    const [servingSize, setServingSize] = useState(recipeDetail.PerServingSize);

    /**
     * This page contain header and footer components
     * in the banner section showing title and image of the recipe with category
     * after that showing information of the recipes and ingredients per serving
     * and then showing all steps for the recipes
     * the last section contain related recipes
     */
    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{__html: JSON.stringify(recipesSchema)}}
                />
            </Head>
            <section className={styles.banner}>
                <img src={recipeDetail.Large_Image.data.attributes.url}
                     alt={recipeDetail.Large_Image.data.attributes.alternativeText}/>
                <div className={'details_container'}>
                    <div className={'content'}>
                        <Link href={'/recipes'}><img alt={'back to recipes'}
                                                     src={'/assets/images/decorations/recipe_inner/recipe_inner_back_to_recipes_polygon.webp'}/>
                            <span>BACK TO RECIPES</span></Link>
                        <h1>{recipeDetail.Banner_Title}</h1>
                        <span><span
                            className={'bold-text'}>Categories:</span> {recipeDetail.Categories.join(' - ')} </span>
                    </div>
                </div>
            </section>
            <section className={styles.container}>
                <div className={'details'}>
                    <div className={'title'}>
                        <h6 dangerouslySetInnerHTML={{__html: recipeDetail.BODY_TITLE}}></h6>
                        <h1>recipe by {recipeDetail.Author}</h1>
                        <div className={'information_per_serving'}>
                            <p>Information per serving</p>
                            <span>Serving size {recipeDetail.PerServingSize}</span>
                        </div>
                        <div className={'item_list'}>
                            <div className={'item'}>
                                <span>Level</span>
                                <p>{recipeDetail.Recipes_Info.Level}</p>
                            </div>
                            <div className={'item'}>
                                <span>Dish</span>
                                <p>{recipeDetail.Recipes_Info.Dish}</p>
                            </div>
                            <div className={'item'}>
                                <span>Type</span>
                                <p>{recipeDetail.Recipes_Info.Type}</p>
                            </div>
                            <div className={'item'}>
                                <span>Preperation time</span>
                                <p>{recipeDetail.Recipes_Info.Preperation_Time} min</p>
                            </div>
                            <div className={'item'}>
                                <span>Cooking time</span>
                                <p>{recipeDetail.Recipes_Info.Cooking_Time} min</p>
                            </div>
                        </div>
                        <div className={'share_button'}>
                            <SILink classes={''}
                                    href={`mailto:?subject=Amazing Recipe by SIDR.com&body=Hey, I came across an amazing recipe on SIDR.com. Check it out: https://sidr.com${router.asPath}`}><img
                                src={'/assets/images/decorations/recipe_inner/recipe_inner_share_via_email_icon.webp'} alt={'share via e-mail'}/> share
                                via e-mail</SILink>
                        </div>
                    </div>
                    <div className={'ingredients'}>
                        <div className={'information_per_serving'}>
                            <span>Ingredients for <input placeholder={'2'} value={servingSize} disabled={true}
                                                         onChange={e => {
                                                             setServingSize(e.currentTarget.value);
                                                         }}></input> servings</span>
                        </div>
                        <div className={'ingredients_per_serving'}>
                            <table>
                                <tbody>
                                {
                                    recipeDetail.Ingredients.map((item: any, index: number) => {
                                        return (<tr key={'ingredient-' + index}>
                                            <td>{item.Value}</td>
                                            <td>{item.Weight}</td>
                                            <td>{item.Title}</td>
                                        </tr>)
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <hr/>
            </section>
            <section className={styles.steps_container}>
                <div className={'steps'}>
                    {
                        recipeDetail.Steps.map((step: any, index: number) => {
                            return (<div className={'step'} key={'step-' + index}>
                                <div className={'step_title'}>
                                    <h1>Step {index + 1}</h1>
                                    <hr className={'hr_line'}/>
                                </div>
                                <p>{step.Description}</p>
                            </div>)
                        })
                    }
                </div>
                <hr/>
            </section>
            {/* Recipes List */}
            <RecipesList relatedRecipes={relatedRecipes}></RecipesList>
        </>
    )
}

export async function getServerSideProps(context: { params: { detail: any; }; resolvedUrl: string; }) {

    const key = context.params.detail;
    let queryObject: any = {
        filters: {
            Link: {$eq: key.toLowerCase()}
        }
    }
    let query = qs.stringify(queryObject, {encodeValuesOnly: true,});


    // Related Products
    let queryObjectRelatedRecipes: any = {
        pagination: {
            page: 1,
            pageSize: 3
        },
        filters: {
            Link: {$ne: key.toLowerCase()}
        },
        sort: ['id:desc'],
    }
    let queryRelatedRecipes = qs.stringify(queryObjectRelatedRecipes, {encodeValuesOnly: true,});

    let recipeDetail = null;
    let relatedRecipes = []
    let recipeId = null;
    try {
        const response = await strapi.getRecipeList(query);
        if (response.status == 200 && response.data && response.data.data) {
            if (response.data.data.length > 0) {
                recipeId = response.data.data[0].id;
                recipeDetail = response.data.data[0].attributes;
            }
        }

        const responseRelatedRecipes = await strapi.getRecipeList(queryRelatedRecipes);
        if (responseRelatedRecipes.status == 200 && responseRelatedRecipes.data && responseRelatedRecipes.data.data) {
            relatedRecipes = responseRelatedRecipes.data.data;
        }
    } catch (e) {
    }
    if (!recipeDetail) {
        return {
            notFound: true,
        }
    }

    // Update View Count
    try {
        let totalViews = recipeDetail.Views == null ? 0 : parseInt(recipeDetail.Views)
        await strapi.updateRecipesView(recipeId, {data: {Views: totalViews + 1}})
    } catch (e) {
    }

    const seoDetails = {
        title: `${recipeDetail.SEO_Title ? recipeDetail.SEO_Title : recipeDetail.Banner_Title} | SIDR®`,
        description: recipeDetail.SEO_Description,
        keyword: recipeDetail.SEO_Keyword,
        image: recipeDetail.Large_Image.data.attributes.url,
        imageAlt: recipeDetail.Large_Image.data.attributes.alternativeText,
        url: context.resolvedUrl,
    }

    let ingredientsForSchema: string[] = [];
    recipeDetail.Ingredients.map((item: any) => {
        ingredientsForSchema.push(`${item.Value} of ${item.Title}`);
    })
    let recipeInstructionsForSchema: { "@type": string; text: any; }[] = [];
    recipeDetail.Steps.map((item: any) => {
        recipeInstructionsForSchema.push({
            "@type": 'HowToStep',
            "text": item.Description,
        });
    })
    let recipesSchema: any = {
        "@context": "https://schema.org/",
        "@type": "Recipe",
        "name": `${recipeDetail.BODY_TITLE}`.replace(/<\/?[^>]+(>|$)/g, ""),
        "image": [
            recipeDetail.Large_Image.data.attributes.url
        ],
        "author": {
            "@type": "Person",
            "name": recipeDetail.Author
        },
        "datePublished": "2023-07-08",
        "description": (recipeDetail.SEO_Title ? recipeDetail.SEO_Title : recipeDetail.Banner_Title),
        "prepTime": `PT${recipeDetail.Recipes_Info.Preperation_Time}M`,
        "cookTime": `PT${recipeDetail.Recipes_Info.Cooking_Time}M`,
        "totalTime": `PT${parseInt(recipeDetail.Recipes_Info.Preperation_Time) + parseInt(recipeDetail.Recipes_Info.Cooking_Time)}M`,
        "keywords": "sidr, sidr honey, sidr honey recipe, recipe",
        "recipeYield": recipeDetail.PerServingSize,
        "recipeCategory": recipeDetail.Recipes_Info.Dish,
        "recipeCuisine": "American",
        "recipeIngredient": ingredientsForSchema,
        "recipeInstructions": recipeInstructionsForSchema,
    }

    return {props: {recipeDetail, relatedRecipes, seoDetails, recipesSchema}}
}

export default RecipesDetail
